import { useEffect, useState } from "react";
import { Copy, Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { bridgeScriptUrl, http } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const CMD = 'powershell -ExecutionPolicy Bypass -File "$env:USERPROFILE\\Downloads\\dainuok-yue-bridge.ps1"';

const Dot = ({ on, label, testId }) => (
  <span data-testid={testId} className="flex items-center gap-2 text-xs">
    <span className={`w-2 h-2 rounded-full ${on ? "bg-emerald-400 shadow-[0_0_8px_#34d399]" : "bg-zinc-600"}`} />
    <span className={on ? "text-emerald-300" : "text-zinc-500"}>{label}</span>
  </span>
);

export const YueBridgeCard = () => {
  const { user } = useAuth();
  const [st, setSt] = useState({ online: false, studio_ok: false });
  useEffect(() => {
    const load = () => http.get("/bridge/status").then((r) => setSt(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);
  const copy = () => navigator.clipboard.writeText(CMD).then(() => toast.success("Komanda nukopijuota"));

  return (
    <div data-testid="yue-bridge-card" className="rounded-2xl border border-[var(--c-violet)]/40 bg-[var(--c-violet)]/[0.06] p-5 space-y-4 rise">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="font-display text-sm">YuE2 Studio jungtis</p>
        <div className="flex gap-4">
          <Dot testId="yue-bridge-status" on={st.online} label={st.online ? "Tiltas prisijungęs" : "Tiltas neprisijungęs"} />
          <Dot testId="yue-studio-status" on={st.studio_ok} label={st.studio_ok ? "YuE2 veikia" : "YuE2 neatsako"} />
        </div>
      </div>
      <ol className="text-sm text-zinc-300 space-y-2.5 list-decimal pl-5">
        <li>Įdiekite ir paleiskite <a href="https://github.com/timoncool/YuE2-Studio/releases/latest" target="_blank" rel="noreferrer" data-testid="yue-download-studio" className="text-[var(--c-violet)] hover:underline inline-flex items-center gap-1">YuE2 Studio<ExternalLink className="w-3 h-3" /></a> (Windows, NVIDIA ≥ 6 GB).</li>
        <li className="space-y-2">
          <span>Atsisiųskite savo asmeninį tilto skriptą:</span>
          <a href={bridgeScriptUrl(user.client_key)} download="dainuok-yue-bridge.ps1" data-testid="yue-download-bridge"
            className="flex w-fit items-center gap-2 px-4 py-2 rounded-full bg-[var(--c-violet)] text-white text-xs font-semibold hover:bg-[#b874f8] transition-colors">
            <Download className="w-3.5 h-3.5" />dainuok-yue-bridge.ps1
          </a>
        </li>
        <li className="space-y-2">
          <span>Paleiskite jį PowerShell lange ir palikite veikti:</span>
          <button data-testid="yue-copy-command" onClick={copy}
            className="flex w-full items-center gap-2 text-left font-mono text-[11px] p-2.5 rounded-lg bg-black/40 border border-[var(--c-line)] text-zinc-300 hover:border-zinc-500 transition-colors">
            <span className="flex-1 break-all">{CMD}</span><Copy className="w-3.5 h-3.5 shrink-0" />
          </button>
        </li>
      </ol>
      <p className="text-xs text-zinc-500 leading-relaxed">Dainos kuriamos jūsų kompiuteryje ir automatiškai įkeliamos čia, su viršeliu ir karaoke. Kol tiltas išjungtas, dainos laukia eilėje.</p>
    </div>
  );
};
